import React from "react";
import Card from "components/card";
import JobPostCard from "./JobPostCard";

const JobListPanel = ({ jobs, selectedJob, onSelect }) => {

    return (
        <Card className="flex flex-col gap-6 rounded-2xl border-2 border-slate-200 shadow-lg overflow-hidden h-full">
            <div className="px-6 pt-6 pb-6 bg-gradient-to-br from-cyan-50 to-emerald-50 border-b rounded-t-xl grid gap-1.5">
                <h4 className="text-[20px] font-medium">
                    Job Post Listings
                </h4>
                <p className="text-[15px] font-normal text-slate-700">
                    Select to view job details
                </p>
            </div>
            <div className="p-4 pb-6">
                <div className="space-y-3 overflow-y-auto">
                    {jobs.map((job) => (
                        <JobPostCard
                            key={job.job_id}
                            title={job.title}
                            job_id={job.job_id}
                            status={job.details?.status}
                            location={job.location}
                            counts={job.details?.counts}
                            client={job.client}
                            selected={selectedJob?.job_id === job.job_id}
                            onClick={() => onSelect(job)}
                        />
                    ))}
                </div>
            </div>
        </Card>
    );
};

export default JobListPanel;